import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Layout from '../../product/components/templates/Layout'
import './AddorUpdateProduct.css'
import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import SecondaryButton from '../../product/components/atoms/SecondaryButton'

import { useFormik } from 'formik'
// import ProductContext from '../../product/context/product/productContext'
import ProductContext from '../../custom/context/product/productContext'
import AuctionContext from '../../product/context/auction/auctionContext'
import UserContext from '../../product/context/user/userContext'
import CommonContext from '../../custom/context/common/commonContext'
import ReportContext from '../../product/context/report/reportContext'
import NetSuiteContext from '../../product/context/thirdParty/netsuite/netSuiteContext'
import * as Yup from 'yup'
import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '../../product/common/components'
import moment from 'moment'

import CustomDialog from '../../product/components/organisms/Dialog'
import { Button } from '@mui/material'
import Loaders from '../../product/components/molecules/Loaders'

const AddorUpdateProduct = (props) => {
    const netSuiteContext = useContext(NetSuiteContext)
    const [isLoading, setIsLoading] = useState(true)

    const {
        getInventoryItem,
        responseStatus: responseStatusNetSuite,
        clearResponse: clearResponseNetSuite,
    } = netSuiteContext

    const [textAreaContent, setTextAreaContent] = useState('')
    const [isButtonDisabled, setIsButtonDisabled] = useState(false)

    const validationArray = Yup.object({
        id: Yup.string().required('Required!'),
    })

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            const internalIds = values.id.split(',')
            getInventoryItem({ id: internalIds })
        },
    })

    const netSuiteInfo = [
        {
            label: 'Net Suite IDs',
            name: 'id',
            type: 'text',
            placeholder: 'Enter the Net suite ID',
            class: '',
            autoFocus: true,
            formik: formik,
        },
    ]

    return (
        <Layout>
            <div className="addorupdate-container">
                <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                        <div className="col-12">
                            <h3 className="addTitle">
                                Please insert all of the NetSuite INTERNAL IDs
                                for each product
                            </h3>
                            <h4 className="addSubtitle">
                                Make sure to follow this format:
                                123456,123457,... etc.
                            </h4>
                        </div>

                        <div className="col-12">
                            <div className="addAct">
                                {mapData(netSuiteInfo)}
                                <PrimaryButton
                                    label="Post"
                                    type="submit"
                                    btnSize="large"
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </Layout>
    )
}

export default AddorUpdateProduct
